import React from 'react';
import { Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as URI from 'urijs';

export interface FilterProp {
  id?: boolean;
  admin_id?: boolean;
  device_id?: boolean;
  name?: boolean;
  date_range?: string;
  owner_id?: boolean;
  role?: boolean;
  child_id?: boolean;
}

function FilterView(props: FilterProp) {
  const uri = new URI.default(window.location.href);
  const query = uri.query(true);
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm({
    defaultValues: query,
  });

  const filterId = props.id ? (
    <Col xs="auto" className="mb-3">
      <Controller
        control={control}
        name="id"
        render={({ field: { onChange, value, ref } }) => (
          <Form.Control
            type="text"
            onChange={onChange}
            value={value || ''}
            ref={ref}
            placeholder="ID"
          />
        )}
      />
    </Col>
  ) : (
    <></>
  );

  const filterName = props.name ? (
    <Col xs="auto" className="mb-3">
      <Controller
        control={control}
        name="name"
        render={({ field: { onChange, value, ref } }) => (
          <Form.Control
            type="text"
            onChange={onChange}
            value={value || ''}
            ref={ref}
            placeholder="名称"
          />
        )}
      />
    </Col>
  ) : (
    <></>
  );

  const filterRole = props.role ? (
    <Col xs="auto" className="mb-3">
      <Controller
        control={control}
        name="role"
        render={({ field: { onChange, value, ref } }) => (
          <Form.Select onChange={onChange} value={value || ''} ref={ref}>
            <option value="">権限</option>
            <option value="admin">管理者</option>
            <option value="user">ユーザー</option>
          </Form.Select>
        )}
      />
    </Col>
  ) : (
    <></>
  );

  const filterAdmin = props.admin_id ? (
    <Col xs="auto" className="mb-3">
      <Controller
        control={control}
        name="admin_id"
        render={({ field: { onChange, value, ref } }) => (
          <Form.Control
            type="text"
            onChange={onChange}
            value={value || ''}
            ref={ref}
            placeholder="管理者"
          />
        )}
      />
    </Col>
  ) : (
    <></>
  );

  const filterDeviceId = props.device_id ? (
    <Col xs="auto" className="mb-3">
      <Controller
        control={control}
        name="device_id"
        render={({ field: { onChange, value, ref } }) => (
          <Form.Control
            type="text"
            onChange={onChange}
            value={value || ''}
            ref={ref}
            placeholder="識別子ID"
          />
        )}
      />
    </Col>
  ) : (
    <></>
  );

  const filterOwnerId = props.owner_id ? (
    <Col xs="auto" className="mb-3">
      <Controller
        control={control}
        name="owner_id"
        render={({ field: { onChange, value, ref } }) => (
          <Form.Control
            type="text"
            onChange={onChange}
            value={value || ''}
            ref={ref}
            placeholder="親機ID"
          />
        )}
      />
    </Col>
  ) : (
    <></>
  );

  const filterChildId = props.child_id ? (
    <Col xs="auto" className="mb-3">
      <Controller
        control={control}
        name="child_id"
        render={({ field: { onChange, value, ref } }) => (
          <Form.Control
            type="text"
            onChange={onChange}
            value={value || ''}
            ref={ref}
            placeholder="子機ID"
          />
        )}
      />
    </Col>
  ) : (
    <></>
  );

  const filterDateRange = props.date_range ? (
    <>
      <Col xs="auto" className="mb-3">
        <InputGroup>
          <InputGroup.Text>{props.date_range}</InputGroup.Text>
          <Controller
            control={control}
            name="start_at"
            render={({ field: { onChange, value, ref } }) => (
              <Form.Control
                type="date"
                onChange={onChange}
                value={value || ''}
                ref={ref}
                placeholder={`${props.date_range}（開始）`}
              />
            )}
          />
          <InputGroup.Text>〜</InputGroup.Text>
          <Controller
            control={control}
            name="end_at"
            render={({ field: { onChange, value, ref } }) => (
              <Form.Control
                type="date"
                onChange={onChange}
                value={value || ''}
                ref={ref}
                placeholder={`${props.date_range}（終了）`}
              />
            )}
          />
        </InputGroup>
      </Col>
    </>
  ) : (
    <></>
  );

  const onSubmit = (values: any) => {
    for (const key of Object.keys(values)) {
      if (values[key]) {
        uri.setQuery(key, values[key]);
      } else {
        uri.removeQuery(key);
      }
    }

    // 強制的にページは0にする
    uri.setQuery('page', 0);

    navigate(uri.pathname() + uri.search());
  };

  return (
    <Form
      onSubmit={handleSubmit(onSubmit)}
      className="p-3 pb-0 border border-secondary"
    >
      <Row>
        {filterId}
        {filterName}
        {filterAdmin}
        {filterDeviceId}
        {filterOwnerId}
        {filterChildId}
        {filterRole}
        {filterDateRange}

        <Col xs="auto" className="text-center text-end">
          <Controller
            control={control}
            name=""
            render={({ field: { ref }, formState }) => (
              <Button
                className="w-100"
                type="submit"
                ref={ref}
                variant="secondary"
              >
                検索
              </Button>
            )}
          />
        </Col>
      </Row>
    </Form>
  );
}

export { FilterView };
